"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.creatorApiEndpoints = void 0;
const creatorApiProxy_1 = require("root/src/shared/creatorApi/endpoints/creatorApiProxy");
const constants_1 = require("root/src/shared/creatorApi/constants");
exports.creatorApiEndpoints = {
    [constants_1.CreatorApiEndpoint.CREATOR_API_PROXY]: creatorApiProxy_1.creatorApiProxyEndpoint,
};
